import { useState } from "react";
import { NavLink, useLocation } from 'react-router-dom'
import logo from "../stock/nexus/logo.png"

function Footer() {
    const location = useLocation();

  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = () => {
    if (!email) return;

    setLoading(true);

    setTimeout(() => {
      setLoading(false);
      setSubscribed(true);
      setEmail("");

      setTimeout(() => {
        setSubscribed(false);
      }, 5000);
    }, 1000); // spinner for 1 second
  };

  
 const visiblePaths = [
     "/", 
    //  "/login", 
    // "/signup", 
    // "/verify-account", 
    // "/verify-account/username", 
    // "/dashboard", 
    // '/trades', 
    // '/transactions', 
    // '/deposits', 
    // '/withdrawals', 
    // '/pendingDeposits', 
];

// 2. Check if the current path is NOT in the list.
// If the path IS NOT in the list, the component SHOULD be hidden.
const shouldHideComponent = !visiblePaths.includes(location.pathname);
    
  return (
    <div style={{ display: shouldHideComponent ? "none" : "block" }}>
    <div className='footer'>
        <div className="footer-container">

            <div className="links">

                <div className="links-left">

                <div className="logo">
                <NavLink to='/' className="logo-container">
                <img src={logo} alt="keystonecapitals" />
                <div className="name"><h3>NEXUS</h3><p>FORGE FX</p></div>
                </NavLink>
                </div>

                <div className="touch">
                    <h2>Get in Touch</h2>

                    <p className="addy">
                        Moonshine St. 14/05 <br /> London, United Kingdom
                    </p>

                <div className="mail">
                    <a href="mailto:support@nexusforge.com">support@nexusforge.com</a>
                    <br />
                     <a
                    href="https://wa.me/message/UOOGIUDWBG5YL1"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Talk to support
                </a>
                </div>

                </div>

                <div className="site-map">
                    <h2>Learn More</h2>

                    <div className="footer-links">
                    <NavLink  to="/#tradables">Tradable Assets</NavLink>
                    <NavLink to="/#faqs">Deposits and Withdrawals</NavLink>
                    <NavLink>Help Center</NavLink>
                    </div>
    
                </div>

                </div>


                <div className="news-letters">
                    <div className="newsletter-container">
                        <h2>Our Newsletter</h2>

                        <p>Subscribe to our Newsletter to get <br /> the latest from us delivered to you.</p>

                     <div className="newsletter">
                    <input 
                        type="text" 
                        placeholder="name@gmail.com" 
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />

                    <button onClick={handleSubscribe} disabled={loading}>
                        {loading
                        ? "..."
                        : subscribed
                            ? "Subscribed"
                            : "Submit"}
                    </button>
                    </div>
                    </div>
                </div>



            </div>

       <div className="disclaimer">
    <p>
        NexusForge FX is a global online brokerage platform providing access to cryptocurrency and forex markets. NexusForge FX is operated by NexusForge Technologies Ltd, registered in Seychelles under registration number 8256612-1. The company’s registered office is at 9A CT House, 2nd Floor, Providence, Mahe, Seychelles.
    </p>

```
<p>
    <strong>Risk Warning:</strong> Trading cryptocurrencies, forex, and other financial instruments involves significant risk and may not be suitable for all investors. The value of digital assets can be highly volatile, and you may lose part or all of your invested capital. Leveraged trading magnifies both potential profits and potential losses. Please ensure you fully understand the risks involved and seek independent advice if necessary.
</p>


<p>
    The information provided on this website is for educational and informational purposes only and should not be considered as financial or investment advice. Nothing on this site constitutes a solicitation, recommendation, or offer to buy or sell any financial product or service. All trading decisions made by users are done at their own discretion and risk.
</p>

<p>
    The content and materials on this website may not be copied, reproduced, or distributed without the prior written consent of NexusForge FX.
</p>

<p>
    NexusForge FX adheres to high industry standards for data protection and cybersecurity. We use encryption, regular audits, and continuous system monitoring to ensure user privacy and transaction integrity.
</p>

<p>
    ¹Most withdrawals on NexusForge FX are processed within minutes; however, processing times may vary depending on the payment provider or blockchain network congestion.
</p>

<p>
    ²Certain deposit methods may include small transaction or network fees to maintain the efficiency and security of our platform.
</p>

<p>
    ³Market volatility, liquidity, and trading volume may cause price fluctuations and variations in spreads on digital assets.
</p>
```

</div>


            <div className="copyright">
        <p>&copy; 2026 NexusForge FX Ltd. All rights reserved.</p>
           <p>Privacy Policy | Terms of Service</p>
            </div>

        </div>
    </div>
    </div>
  )
}

export default Footer